import { BANKS } from '../../../../constants';

// Ракурсы фото авто для банков. Вынесены из компонента, чтобы покрыть тестами
// без React и http-клиента: состав ракурсов решает две вещи сразу — лишний
// обязательный запирает менеджера в блоке, недостающий уводит заявку в отказ.
//
// Соответствие типам документов (completed_order_documents_types):
// 46 «Фото авто» (serialNumberId 1..4 и 5..10), 47 «Фото VIN», 45 «Техпаспорт»,
// 48 «Фото одометра».

// banks — каким банкам нужен снимок. Freedom просит пять ракурсов и техпаспорт,
// Jet Finance — те же плюс одометр, второй VIN и подкапотное с салоном.
// required относится к Freedom: без этих пяти он отклонит заявку.
// newCar — машина из салона: залог оценивать нечего, Jet Finance ждёт только
// снимок VIN, и Freedom по новой машине фото не просит вовсе.
const FREEDOM = BANKS.FREEDOM;
const JETFIN = BANKS.JETFIN;
const BOTH = [FREEDOM, JETFIN];

// «Фото VIN» в справочнике типов документов: серия 1 — выбитый, серия 2 — наклейка.
const VIN_TYPE_ID = 47;

export const SLOTS = [
  { key: 'FRONT_SIDE_IMAGE', label: 'Спереди', typeId: 46, serial: 1, required: true, banks: BOTH },
  { key: 'LEFT_SIDE_IMAGE', label: 'Слева', typeId: 46, serial: 2, required: true, banks: BOTH },
  { key: 'RIGHT_SIDE_IMAGE', label: 'Справа', typeId: 46, serial: 3, required: true, banks: BOTH },
  { key: 'BACK_SIDE_IMAGE', label: 'Сзади', typeId: 46, serial: 4, required: true, banks: BOTH },
  {
    key: 'VIN_IMAGE',
    label: 'Фото VIN',
    hint: 'выбитый на кузове',
    typeId: 47,
    serial: 1,
    required: true,
    banks: BOTH,
  },
  {
    key: 'TECHNICAL_PASSPORT_FRONT_SIDE_IMAGE',
    label: 'Техпаспорт (лицевая)',
    typeId: 45,
    serial: 1,
    required: false,
    banks: BOTH,
  },
  { key: 'ODOMETER_IMAGE', label: 'Пробег', typeId: 48, serial: 1, required: false, banks: [JETFIN] },
  {
    key: 'VIN2_IMAGE',
    label: 'Второй VIN',
    hint: 'наклейка',
    typeId: 47,
    serial: 2,
    required: false,
    banks: [JETFIN],
  },
  { key: 'ENGINE_IMAGE', label: 'Двигатель', typeId: 46, serial: 5, required: false, banks: [JETFIN] },
  { key: 'INTERIOR_IMAGE', label: 'Салон', typeId: 46, serial: 6, required: false, banks: [JETFIN] },
  { key: 'PANEL_IMAGE', label: 'Панель приборов', typeId: 46, serial: 7, required: false, banks: [JETFIN] },
  { key: 'SEATS_IMAGE', label: 'Сиденья', typeId: 46, serial: 8, required: false, banks: [JETFIN] },
  { key: 'TRANSMISSION_IMAGE', label: 'Коробка', typeId: 46, serial: 9, required: false, banks: [JETFIN] },
  { key: 'TRUNK_IMAGE', label: 'Багажник', typeId: 46, serial: 10, required: false, banks: [JETFIN] },
];

// Какие ракурсы показать менеджеру. Вынесено из компонента, чтобы покрыть
// тестами: лишний обязательный ракурс блокирует выбор банка, недостающий —
// уводит заявку в отказ.
export const slotsFor = (banks = [], { newCar = false } = {}) => {
  // Новая машина: оценивать залог нечего, банк ждёт только VIN — но оба, и
  // выбитый на кузове, и наклейку (Albina из Jet Finance, 08.10.2026). Второй
  // снимок у б/у авто необязательный, здесь без него заявка не поедет.
  if (newCar) {
    if (!banks.includes(JETFIN)) return [];

    return SLOTS.filter((slot) => slot.typeId === VIN_TYPE_ID).map((slot) => ({
      ...slot,
      required: true,
    }));
  }

  // Б/у и комиссионные: только те ракурсы, которые нужны банкам этой сделки —
  // в сделке без Jet Finance менеджеру незачем снимать багажник и панель приборов.
  return SLOTS.filter((slot) => slot.banks.some((bank) => banks.includes(bank)));
};
